/**
 * Returns true when the page is running on a QA proxy (wthubspot domain).
 * Copied from pricing-pages-lib/utils/proxyUtils — do not import from there.
 */
export const getIsQAProxy = (hostname = window.location.hostname) => hostname.indexOf('wthubspot') >= 0;

/**
 * Returns true when running inside a Selenium acceptance-test session.
 * Copied from pricing-pages-ui/utils/testUtils — do not import from there.
 */
export const getIsAcceptanceTest = (webdriver = window.navigator.webdriver) => !!webdriver;